import React from 'react';
import { Modal, Backdrop, Box, CircularProgress, Typography } from '@mui/material';

const LoadingPopUp = ({ open, blocking = false, message = 'Yükleniyor...' }) => (
    <Modal
        open={open}
        BackdropComponent={Backdrop}
        BackdropProps={{
            sx: {
                backgroundColor: blocking ? 'rgba(0, 0, 0, 0.35)' : 'transparent',
            },
        }}
        sx={{
            pointerEvents: blocking ? 'auto' : 'none',
            outline: 'none',
            zIndex: (theme) => theme.zIndex.modal + 2,
        }}
        closeAfterTransition
    >
        <Box
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: blocking ? 3 : 0,
                p: 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                pointerEvents: 'auto',
                border: 'none',
            }}
        >
            <CircularProgress sx={{ mb: message ? 1 : 0 }} />
            {message ? <Typography variant="body2">{message}</Typography> : null}
        </Box>
    </Modal>
);

export default LoadingPopUp;
